import { Navigate, Route, Routes } from 'react-router-dom';
import { Config } from './pages/Config';
import { Spinner } from './pages/Spinner';

export function App() {
  return (
    <Routes>
      <Route path="/spinner" element={<Spinner />} />
      <Route path="/config" element={<Config />} />
      <Route path="*" element={<Navigate to="/spinner" replace />} />
    </Routes>
  );
}
